import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '@/lib/cn';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  interactive?: boolean;
}

export function Card({ children, className, interactive, ...rest }: CardProps) {
  return (
    <div
      className={cn(
        'bg-bg-surface rounded-2xl shadow-card border border-white/5',
        interactive && 'transition active:scale-[0.99] hover:border-white/10 cursor-pointer',
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  );
}
